import { useTranslation } from "react-i18next"
import secondsToHms from "../../../../utility/SecondToHms"


function AbsenceQuickView({
    title,
    icon = "fa-solid fa-eye",
    data
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const dataSample = {
        today: [
            { name: "Mario Rossi", reason: "HOLIDAY" },
            { name: "Giuseppe Righetti", reason: "PERMIT", hours: 3600 },
            { name: "Michele Bianco", reason: "PERMIT", hours: 5400 }
        ]
    }

    //data = dataSample

    const todayAbsents = data.today != null ? data.today.filter(absence => absence.reason != "PERMIT") : []
    const todayAbsencesCount = todayAbsents.length

    const todayPermissions = data.today != null ? data.today.filter(absence => absence.reason == "PERMIT") : []
    const todayPermissionsTotal = todayPermissions.length > 0 ? todayPermissions.reduce((partialSum, a) => partialSum + a.hours, 0) : 0

    const absenceTypeIcon = (reason) => {
        switch (reason) {
            case "HOLIDAY": return <i className="fa-solid fa-umbrella-beach"></i>
            case "SICK": return <i className="fa-solid fa-house-chimney-medical"></i>
            case "PERMIT": return <i className="fa-solid fa-clock"></i>
            default: return
        }
    }

    return (
        <div className="card bg-black bg-opacity-10 text-white mb-5">
            <div className="card-header">
                <i className={`${icon}`}></i> {title ? title : t("absenceReport:menu.quick_view")}
            </div>
            <div className="card-body text-center">
                <div className="row ">
                    <div className="col-sm">
                        <h2>{t("time.today")}</h2>
                        {new Date().toLocaleDateString()}
                    </div>
                    <div className="col-sm">
                        <p><i className="fa-solid fa-users"></i> {t("absenceReport:entity.absent")}</p>
                        <h4>{todayAbsencesCount}</h4>
                        {
                            todayAbsencesCount > 0 &&
                            <div className="absents-container">
                                {
                                    todayAbsents.map(absent => (
                                        <div>{absenceTypeIcon(absent.reason)} <span className="m-2" /> {absent.name}</div>
                                    ))
                                }
                            </div>
                        }
                    </div>
                    <div className="col-sm">
                        <p><i className="fa-solid fa-user-clock"></i> {t("absenceReport:entity.permitts")}</p>
                        <h4>{todayPermissionsTotal > 0 ? secondsToHms(todayPermissionsTotal) : "0 h 0 mins"}</h4>
                        {
                            todayPermissionsTotal > 0 &&
                            <div className="absents-container">
                                {
                                    todayPermissions.map(absent => (
                                        <div>{absent.name} <span className="m-2" /> {absenceTypeIcon(absent.reason)} {secondsToHms(absent.hours)}</div>
                                    ))
                                }
                            </div>
                        }
                    </div>
                </div>

                <div className="row opacity-50" style={{ display: "none" }}>
                    <div className="col-sm">
                        <h5>Tomorrow</h5>
                    </div>
                    <div className="col-sm-5">
                        <h3>3</h3>
                    </div>

                    <div className="col-sm-5">
                        <h3>1:45 h</h3>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default AbsenceQuickView